export const PROMOTION_LABEL_TITLE_TABS = {
	GENERAL_INFO: 'General info',
	CONDITION: 'Condition',
	REWARD: 'Reward',
	DISPLAYING: 'Displaying',
	COUPON: 'e-Coupon',
};